module.exports = __webpack_public_path__ + "static/img/post_02.8a7c078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post_02.jpg
// module id = SM1e
// module chunks = 0